export default {
  meta: {
    title: "Basetao Spreadsheet: Products, Reviews & Shipping Guide",
    description: "Independent resource hub for Basetao Spreadsheet — find products, compare sellers, check QC photos, shipping costs and whether Basetao is legit.",
  },
  brand: "Basetao Sheet",
  nav: {
    home: "Home",
    categories: "Shop Categories",
    shoppingGuide: "Shopping Guide",
    readGuide: "Read the Guide",
    safety: "Safety",
  },
  button: {
    buyNow: "Buy It Now",
    basetaoSpreadsheet: "Basetao Spreadsheet",
    readGuide: "Read the Guide",
    readArticle: "Read the Full Article",
    exploreCategories: "Explore Categories",
    backHome: "Back to Home",
    visitMain: "Visit Main Website",
    viewAll: "View All",
  },
  cat: {
    shoes: "Shoes",
    hoodies: "Hoodies / Sweaters",
    tshirts: "T-Shirts",
    jackets: "Jackets",
    pants: "Pants / Shorts",
    headwear: "Headwear",
    sets: "Sets",
    underwear: "Underwear / Underpants",
    jersey: "Jersey",
    accessories: "Accessories",
    bags: "Bags",
    belts: "Belts",
    perfumes: "Perfumes",
    other: "Other Stuff",
  },
  notFound: {
    title: "Page Not Found",
    desc: "The page you are looking for does not exist or has been moved.",
  },
  footer: {
    tagline: "Independent informational resource about Basetao Spreadsheet.",
    quickLinks: "Quick Links",
    categories: "Categories",
    disclaimer: "Basetao Sheet is an independent informational resource and is not officially affiliated with Basetao. Information may change and should be verified before purchasing or paying.",
    allRights: "All rights reserved.",
  },
  articleMeta: {
    shortAnswerLabel: "Short Answer",
    tocTitle: "Table of Contents",
    checklistTitle: "Key Points to Check",
    faqTitle: "Frequently Asked Questions",
    conclusionTitle: "The Bottom Line",
    authorLabel: "Author",
    author: "Basetao Sheet Editorial Team",
    publishedLabel: "Published",
    published: "2026",
    updatedLabel: "Updated",
    updated: "August 2026",
    disclaimer:
      "Basetao Sheet is an independent informational resource and is not officially affiliated with Basetao. Information can change and should be verified before purchasing or paying.",
  },
};